<template>
  <div style="margin-top: 100px">
    <div style="border: black solid;border-radius: 20px;width: 500px;margin: auto;padding: 30px 50px">
      <div style="padding-bottom: 10px;text-align: center">
        <h3>登录页面</h3>
      </div>
      <el-form ref="form" :model="form" label-width="auto" label-position="left">
        <el-form-item label="用户名">
          <el-input v-model="form.username" auto-complete="on"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="form.password" auto-complete="on" show-password></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleLogin">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import {login, logout} from "@/api/login";
import store from "@/store";
import router from "@/router";

export default {
  name: "Login",
  data() {
    return {
      form: {
        username: undefined,
        password: undefined
      },
      rules: [],
      time: 0
    }
  },
  methods: {
    handleLogin() {
      login(this.form.username, this.form.password).then(() => {
        this.$axios.get("/public/account").then((res => {
          this.$store.commit("login", res.data)
          if (store.state.user.isAdmin) {
            router.addRoute({path: "/", redirect: "/admin/users"})
          } else {
            router.addRoute({path: "/", redirect: "/app/apps"})
          }
          this.$router.push("/")
        })).catch(() => {
          logout().then(() => {
            if (this.time < 1) {
              this.time = 1
              this.handleLogin()
            }})
        })
      })
    }
  }
}
</script>

<style scoped>

</style>
